import React from 'react';
import './App.css';
import './i18n';
import Header from './Header';
import Hero from './Hero';
import Poles from './Poles';
import Partnerships from './Partnerships';
import Stats from './Stats';
import About from './About';
import Vision from './Vision';
import Skills from './Skills';
import Services from './Services';
import Values from './Values';
import Experience from './Experience';
import Projects from './Projects';
import Education from './Education';
import Interests from './Interests';
import Contact from './Contact';

function App() {
  return (
    <div className="portfolio-container">
      <Header />
      <main>
        <Hero />
        <Poles />
        <Partnerships />
        <Stats />
        <About />
        <Vision />
        <Skills />
        <Services />
        <Values />
        <Experience />
        <Projects />
        <Education />
        <Interests />
        <Contact />
      </main>
    </div>
  );
}

export default App;
